// ══════════════════════════════════════════════════════════════
// COMPASS – Notification (In-App Feed) Reducer
// ══════════════════════════════════════════════════════════════
import { createReducer, on } from '@ngrx/store';
import { NotificationActions } from './notification.actions';
import { initialNotificationState, NotificationState } from './notification.state';

export const notificationReducer = createReducer<NotificationState>(
  initialNotificationState,

  on(NotificationActions.refreshBell, (state): NotificationState => ({
    ...state,
    loadingBell: true,
    error: null,
  })),

  on(NotificationActions.refreshBellSuccess, (state, { items }): NotificationState => ({
    ...state,
    items,
    unreadCount: items.filter((n) => n.status === 'UNREAD').length,
    loadingBell: false,
    error: null,
  })),

  on(NotificationActions.refreshBellFailure, (state, { error }): NotificationState => ({
    ...state,
    loadingBell: false,
    error,
  })),

  on(NotificationActions.openBellMenu, (state): NotificationState => ({
    ...state,
    polling: true,
  })),

  on(NotificationActions.pollSuccess, (state): NotificationState => ({
    ...state,
    polling: false,
  })),

  on(NotificationActions.pollFailure, (state, { error }): NotificationState => ({
    ...state,
    polling: false,
    error,
  })),

  on(NotificationActions.clearNotifications, (): NotificationState => ({
    ...initialNotificationState,
  })),
);
